import Vue from 'vue'

new Vue().$mount('#app')
